import { Component, Input, Output, EventEmitter, OnInit, DestroyRef, inject, signal, computed } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AdminApiService } from 'src/app/admin/services/admin-api.service';
import { ISystemUpdateNotificationDTO } from '../../models/system-update-notification';

@Component({
  selector: 'app-system-banner',
  standalone: false,
  templateUrl: './system-notification-banner.component.html',
})
export class SystemNotificationBannerComponent implements OnInit {

  private readonly adminApiService = inject(AdminApiService);
  private readonly destroyRef = inject(DestroyRef);

  readonly message = signal<string | null>(null);

  readonly visible = computed(() => !!this.message());

 ngOnInit(): void {
    this.adminApiService.SystemUpdateNotification.getSingle()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((dto: ISystemUpdateNotificationDTO | null) => {
        if (dto) {
          const dateStr = new Date(dto.updateDate).toLocaleDateString('en-GB');
          this.message.set(`The system will be unavailable on ${dateStr} from ${this.formatTime(dto.updateStartTime)} to ${this.formatTime(dto.updateEndTime)} UK local time for scheduled updates`);
        }
      });
  }

  private formatTime(time: string): string {
    // If time is in format "HH:mm:ss", trim it to "HH:mm"
    if (time?.match(/^\d{2}:\d{2}:00$/)) {
      return time.slice(0, 5);
    }
    return time;
  }
}